import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationsHelperService {
  countNotifications = new BehaviorSubject<number>(0);
}
